import { render } from "./TwoFactorAuthenticationDone.vue?vue&type=template&id=c580f6ce&scoped=true"
const script = {}

import "./TwoFactorAuthenticationDone.vue?vue&type=style&index=0&id=c580f6ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c580f6ce"]])

export default __exports__